import { render, staticRenderFns } from "./Advice.vue?vue&type=template&id=709221a8&scoped=true&"
import script from "./Advice.vue?vue&type=script&lang=js&"
export * from "./Advice.vue?vue&type=script&lang=js&"
import style0 from "./Advice.vue?vue&type=style&index=0&id=709221a8&lang=scss&scoped=true&"
import style1 from "./Advice.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709221a8",
  null
  
)

export default component.exports